module.exports = __webpack_public_path__ + "img/set4.f53477d1.svg";